const articleContentWrapper = document.getElementById('article-content-wrapper');
// const mobile = /Mobi/.test(navigator.userAgent);
const mobile = /Mobi/.test(navigator.userAgent) && !/iPad/.test(navigator.userAgent);

if (articleContentWrapper && !(mobile || window.innerWidth < 1024)) {
  const galleryEmbed = articleContentWrapper.querySelectorAll('.xo-gallery');
  const articleFeaturedImage = document.getElementById('article-featured-image');


  for (let i = 0; i < galleryEmbed.length; i++) {
	articleFeaturedImage.appendChild(galleryEmbed[i]);
  }
}